import { z } from "zod";
import { IUninstallReason } from "../interfaces/IUninstallReason";
export const uninstallFeedbackSchema = z.object({
    reason: z.nativeEnum(IUninstallReason),
    comment: z.string(),
});
